import { jsx as _jsx } from "react/jsx-runtime";
import { StorefrontFillIcon } from '@yonderland/andes-icons';
import { ButtonAlpha, useMediaQueryMatchesOnDesktop, useMediaQueryMatchesOnMobile, } from '@yonderland/andes-react';
import { useProductDetailContext } from '../../../containers/product/ProductDetailV2Container';
import ZendeskWidgetUtil from '../../../util/ZendeskWidgetUtil';
export const StoreFinderButton = ({ text, selectedSku, isStickyBar, isOneSizeProduct, openCC, sizeForgotten, variant = 'secondary', theme = 'branded', iconProps = {
    source: StorefrontFillIcon,
    size: 'sm',
}, buttonSize, }) => {
    const { ctaRef } = useProductDetailContext();
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const isMobile = useMediaQueryMatchesOnMobile();
    const hideText = !isDesktop && !!isStickyBar && !isOneSizeProduct;
    const openClickAndCollect = () => {
        openCC();
        ZendeskWidgetUtil.updateZIndex(1);
    };
    const handleClick = () => (!selectedSku ? sizeForgotten() : openClickAndCollect());
    return (_jsx(ButtonAlpha, { innerRef: !isStickyBar ? ctaRef : undefined, iconRight: hideText ? iconProps : undefined, iconLeft: !hideText ? iconProps : undefined, fullWidth: !isStickyBar || (isMobile && !!isOneSizeProduct), size: !isStickyBar ? (buttonSize !== null && buttonSize !== void 0 ? buttonSize : 'md') : 'sm', onClick: handleClick, variant: variant, theme: theme, text: !hideText && text, testId: "view_stock" }));
};
